// Trilingual content: English (en), French (fr), Kiswahili (sw)
export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "sw", label: "Kiswahili", short: "SW" },
];

export const translations = {
  en: {
    lang: { choose: "Language" },
    booking: {
      pickDate: "1. Pick a date", pickTime: "2. Pick a time slot (China time, GMT+8)",
      noSlots: "No free slots on this date — please try another day.",
      loadingSlots: "Loading available times…", bookBtn: "Confirm Booking",
      success: "Your consultation is booked! We'll email you a confirmation shortly.",
      slotTaken: "That slot was just taken — please pick another.",
      chooseSlotFirst: "Please pick a date and time slot first.",
    },
    blogNews: { overline: "Insights", title: "Blog & News", viewAll: "View all articles" },
    caseStudies: {
      overline: "Case Studies", title: "Real results for real importers",
      subtitle: "See how startups, retailers and procurement teams used Unicorn Valley Group to source safer and grow faster.",
      challenge: "The Challenge", approach: "Our Approach", results: "The Results",
      back: "All case studies", read: "Read case study", watch: "Watch client video stories",
    },
    nav: {
      services: "Services", industries: "Industries", products: "Products",
      startBrand: "Start Your Brand", blog: "Trade Intelligence", caseStudies: "Case Studies",
      tools: "Tools", about: "About", login: "Client Login", dashboard: "Dashboard",
      admin: "Admin", logout: "Logout", requestQuote: "Request a Quote",
    },
    hero: {
      overline: "China Sourcing · Manufacturing · Global Trade",
      titlePre: "Source smarter from China. ", titleHighlight: "Trade globally",
      titlePost: " with confidence.",
      subtitle: "We connect international buyers with verified manufacturers — handling sourcing, quality control, secure payments and door-to-door logistics, so you import with total peace of mind.",
      ctaQuote: "Request a Quote", ctaConsult: "Book a Free Consultation", watch: "Watch how it works",
    },
    trust: {
      verifiedManufacturers: "Verified Manufacturers", securePayments: "Secure Trade Payments",
      doorToDoor: "Door-to-Door Shipping", qa: "AQL Quality Assurance",
    },
    marquee: { trustedBy: "Trusted by buyers shipping to 47+ countries" },
    services: {
      overline: "What we do", title: "End-to-end trade services, under one roof",
      subtitle: "From the first supplier search to the final-mile delivery, we manage every step so you don't have to juggle a dozen vendors.",
      viewAll: "View all services →", learnMore: "Learn more",
    },
    industries: {
      overline: "Industries we serve", title: "Built for buyers across every sector",
      subtitle: "Whether you're a solo Amazon seller or a government procurement team, our sourcing engine scales to your needs.",
    },
    stats: {
      overline: "Why choose us", title: "A track record international buyers trust",
      clients: "Clients served worldwide", factories: "Factories verified",
      countries: "Countries served", containers: "Containers shipped",
    },
    how: {
      overline: "How it works", title: "From inquiry to delivery in four steps",
      subtitle: "A transparent, managed process that keeps you informed at every milestone.",
      s1: { title: "Share Your Requirements", desc: "Tell us what you want to source, your target price, and destination market." },
      s2: { title: "We Source & Verify", desc: "We shortlist verified factories, negotiate pricing, and arrange samples." },
      s3: { title: "Quality Control", desc: "Pre-shipment AQL inspections ensure your goods meet spec before they ship." },
      s4: { title: "Ship & Deliver", desc: "We handle freight, customs and door-to-door delivery — fully tracked." },
    },
    categories: {
      overline: "Product categories", title: "Source virtually anything, at any scale",
      subtitle: "A glimpse of the categories we handle daily — from one carton to full container loads.",
      viewAll: "Explore all categories →",
    },
    startBrand: {
      overline: "Start your brand", title: "Launch your own private label & Amazon FBA brand",
      subtitle: "Turn a product idea into a market-ready brand. We handle OEM/ODM development, custom packaging and FBA logistics — so you can focus on selling.",
      cta: "Start Your Brand", badge: "Idea to live listing",
      p1: "Low-MOQ pilot production runs", p2: "Custom branding & retail-ready packaging",
      p3: "Amazon FBA prep, labeling & compliance", p4: "Dedicated brand manager from day one",
    },
    video: {
      overline: "See it for yourself", title: "Factory visits, inspections & client proof",
      subtitle: "Transparency builds trust. Watch real footage from our factory audits, QC inspections and client success stories.",
      viewAll: "View all videos →",
    },
    testimonials: {
      overline: "Client proof", title: "What buyers around the world say",
      subtitle: "Real results from importers, brands and procurement teams who trust us with their supply chain.",
    },
    leadMagnet: {
      tag: "Free download", namePh: "Full name", emailPh: "Work email", companyPh: "Company (optional)",
      submit: "Download the free guide", preparing: "Preparing…",
      successTitle: "Check your download", success: "We've also emailed you a copy.",
    },
    cta: {
      title: "Ready to source smarter and trade with confidence?",
      subtitle: "Get a tailored quote in 24–48 hours, or talk to a sourcing specialist today. No commitment, no pressure.",
      requestQuote: "Request a Quote", whatsapp: "Chat on WhatsApp",
    },
    currency: {
      live: "Live FX",
      note: "Indicative exchange rates — open our free currency & shipping tools",
    },
    marketplaces: {
      overline: "One partner, every marketplace",
      title: "We source across all major China marketplaces",
      subtitle: "Alibaba, Made-in-China, 1688, Pinduoduo and more — we verify suppliers, negotiate factory-direct pricing and consolidate your orders into one shipment.",
      cta: "Source from here",
      p0: "Global B2B wholesale",
      p1: "Verified China manufacturers",
      p2: "Domestic China wholesale prices",
      p3: "Factory-direct group deals",
      p4: "Small-order wholesale",
      p5: "Retail & dropshipping",
    },
    about: {
      heroOverline: "About us",
      heroTitle: "Your trusted partner in China sourcing & global trade",
      heroSubtitle: "Unicorn Valley Group is a premium sourcing, manufacturing and logistics partner — built to give international buyers a safer, smarter way to trade.",
      whoOverline: "Who we are",
      whoTitle: "A global consultancy, not just a freight forwarder",
      whoP1: "We started Unicorn Valley Group because importing from China shouldn't mean sleepless nights worrying about fraud, quality or delays. With teams on the ground in Shenzhen, Guangzhou and Ningbo, we operate as your eyes, ears and negotiators inside China.",
      whoP2: "From startups launching their first product to government teams procuring at scale, our clients rely on us for honest advice, verified suppliers and end-to-end execution.",
      statYears: "Years combined trade expertise",
      statOffices: "Offices across China",
      statRetention: "Client retention rate",
      missionTitle: "Our Mission",
      missionDesc: "To make global sourcing transparent, safe and effortless for buyers everywhere — eliminating the risk and complexity of trading with China.",
      visionTitle: "Our Vision",
      visionDesc: "To be the most trusted bridge between international buyers and Chinese manufacturing, powering the next generation of global brands.",
      promiseTitle: "Our Promise",
      promiseDesc: "Verified factories, rigorous quality control and protected payments — every order, every time, no exceptions.",
      coverageTitle: "Global coverage",
      coverageSubtitle: "We ship to 47+ countries with dedicated import expertise in key markets:",
    },
    servicesPage: {
      heroOverline: "Our services",
      heroTitle: "Everything you need to import from China",
      heroSubtitle: "A complete, managed trade service — from finding the right factory to delivering goods at your door.",
      explore: "Explore service",
    },
    industriesPage: {
      heroOverline: "Industries",
      heroTitle: "Tailored sourcing for every sector",
      heroSubtitle: "We understand the unique compliance, volume and quality needs of each industry we serve.",
      sourceFor: "Source for this industry →",
    },
    blogPage: {
      heroOverline: "Trade Intelligence Center",
      heroTitle: "Insights to import smarter",
      heroSubtitle: "Practical guides on sourcing, logistics, quality and global trade — written by our China-based experts.",
      readArticle: "Read article",
      all: "All",
    },
    countryPage: {
      home: "Home", destinations: "Import Destinations",
      importTitlePre: "Import from China to", getQuoteTo: "Get a Quote to",
      bookConsult: "Book a Consultation", shippingTo: "Shipping to",
      transitTitle: "Transit times & freight modes",
      seaFreight: "Sea Freight", airFreight: "Air Freight", express: "Express",
      popularImports: "Popular imports to", customsOverline: "Customs & compliance",
      importingToPre: "Importing to", importingToPost: ", done by the book",
      faq: "FAQ", otherDestinations: "Other import destinations",
    },
    footer: {
      tagline: "Your premium China sourcing, manufacturing and global trade partner. Verified factories, quality assured, delivered worldwide.",
      explore: "Explore", company: "Company", getInTouch: "Get in touch",
      aboutUs: "About Us", resources: "Resources", bookConsult: "Book Consultation",
      requestQuote: "Request a Quote", clientLogin: "Client Login", destinations: "Import Destinations",
      rights: "All rights reserved.", premium: "Premium China Sourcing · Manufacturing · Global Trade",
    },
    contact: {
      overline: "Get in touch", title: "Let's start your sourcing project",
      subtitle: "Request a quote, book a free consultation or just ask us a question. We respond within 24 hours.",
      tabQuote: "Request a Quote", tabConsult: "Book Consultation", tabGeneral: "General Inquiry",
      name: "Full name *", email: "Email *", phone: "Phone / WhatsApp", company: "Company",
      quantity: "Quantity (e.g. 500 units / 1x40ft)", destination: "Destination country *",
      product: "Describe the product(s) you want to source *", prefDate: "Preferred date",
      prefTime: "Preferred time", topic: "Topic (e.g. private label, logistics)",
      consultMsg: "Anything we should know?", generalMsg: "How can we help? *",
      submitQuote: "Get My Quote", submitConsult: "Book Consultation", submitGeneral: "Send Message",
      submitting: "Submitting…", thankYou: "Thank you!",
      talkTo: "Talk to us directly", messageUs: "Message us now",
      whyChoose: "Why buyers choose us",
      why1: "Reply within 24 hours", why2: "Quotes in 24–48 hours",
      why3: "No obligation, no pressure", why4: "Verified factories only",
      chatWhatsapp: "Chat on WhatsApp",
      successQuote: "Quote request received. We'll send your tailored quote within 24-48 hours.",
      successConsult: "Consultation requested. We'll confirm your slot by email shortly.",
      successGeneral: "Thank you! Our team will get back to you within 24 hours.",
      tabSupplier: "Verify a Supplier", tabAudit: "Factory Audit",
      supplierName: "Supplier name *", supplierContact: "Supplier website / WeChat / URL",
      productInterest: "Product of interest", supplierNotes: "What would you like us to check?",
      factoryName: "Factory / supplier name *", factoryLocation: "Factory location (city)",
      auditType: "Select audit type", auditNotes: "Anything specific to inspect?",
      submitSupplier: "Request Verification", submitAudit: "Request Audit",
      successSupplier: "Verification request received. Our team will report back within 2-3 business days.",
      successAudit: "Audit request received. We'll confirm scope and scheduling within 24 hours.",
    },
  },

  fr: {
    lang: { choose: "Langue" },
    booking: {
      pickDate: "1. Choisissez une date", pickTime: "2. Choisissez un créneau (heure de Chine, GMT+8)",
      noSlots: "Aucun créneau libre à cette date — essayez un autre jour.",
      loadingSlots: "Chargement des créneaux…", bookBtn: "Confirmer le rendez-vous",
      success: "Votre consultation est réservée ! Vous recevrez une confirmation par e-mail.",
      slotTaken: "Ce créneau vient d'être pris — choisissez-en un autre.",
      chooseSlotFirst: "Veuillez d'abord choisir une date et un créneau.",
    },
    blogNews: { overline: "Actualités", title: "Blog & Actualités", viewAll: "Voir tous les articles" },
    caseStudies: {
      overline: "Études de cas", title: "Des résultats concrets pour de vrais importateurs",
      subtitle: "Découvrez comment des startups, détaillants et équipes d'achat utilisent Unicorn Valley Group pour un sourcing plus sûr et une croissance plus rapide.",
      challenge: "Le défi", approach: "Notre approche", results: "Les résultats",
      back: "Toutes les études de cas", read: "Lire l'étude de cas", watch: "Voir les vidéos clients",
    },
    nav: {
      services: "Services", industries: "Secteurs", products: "Produits",
      startBrand: "Lancez votre marque", blog: "Intelligence commerciale", caseStudies: "Études de cas",
      tools: "Outils", about: "À propos", login: "Espace client", dashboard: "Tableau de bord",
      admin: "Admin", logout: "Déconnexion", requestQuote: "Demander un devis",
    },
    hero: {
      overline: "Sourcing en Chine · Fabrication · Commerce mondial",
      titlePre: "Sourcez plus intelligemment en Chine. ", titleHighlight: "Commercez mondialement",
      titlePost: " en toute confiance.",
      subtitle: "Nous connectons les acheteurs internationaux à des fabricants vérifiés — sourcing, contrôle qualité, paiements sécurisés et logistique porte-à-porte — pour importer l'esprit tranquille.",
      ctaQuote: "Demander un devis", ctaConsult: "Réserver une consultation gratuite", watch: "Voir comment ça marche",
    },
    trust: {
      verifiedManufacturers: "Fabricants vérifiés", securePayments: "Paiements sécurisés",
      doorToDoor: "Livraison porte-à-porte", qa: "Assurance qualité AQL",
    },
    marquee: { trustedBy: "La confiance d'acheteurs expédiant vers plus de 47 pays" },
    services: {
      overline: "Ce que nous faisons", title: "Des services commerciaux complets, sous un même toit",
      subtitle: "De la première recherche de fournisseur à la livraison finale, nous gérons chaque étape pour vous éviter de jongler avec des dizaines de prestataires.",
      viewAll: "Voir tous les services →", learnMore: "En savoir plus",
    },
    industries: {
      overline: "Secteurs que nous servons", title: "Conçu pour les acheteurs de tous les secteurs",
      subtitle: "Que vous soyez un vendeur Amazon indépendant ou une équipe d'achats publics, notre moteur de sourcing s'adapte à vos besoins.",
    },
    stats: {
      overline: "Pourquoi nous choisir", title: "Un palmarès qui inspire confiance",
      clients: "Clients servis dans le monde", factories: "Usines vérifiées",
      countries: "Pays desservis", containers: "Conteneurs expédiés",
    },
    how: {
      overline: "Comment ça marche", title: "De la demande à la livraison en quatre étapes",
      subtitle: "Un processus transparent et géré qui vous tient informé à chaque étape.",
      s1: { title: "Partagez vos besoins", desc: "Dites-nous ce que vous voulez sourcer, votre prix cible et le marché de destination." },
      s2: { title: "Nous sourçons et vérifions", desc: "Nous présélectionnons des usines vérifiées, négocions les prix et organisons les échantillons." },
      s3: { title: "Contrôle qualité", desc: "Les inspections AQL avant expédition garantissent la conformité de vos marchandises." },
      s4: { title: "Expédition et livraison", desc: "Nous gérons le fret, la douane et la livraison porte-à-porte — entièrement suivie." },
    },
    categories: {
      overline: "Catégories de produits", title: "Sourcez pratiquement tout, à toute échelle",
      subtitle: "Un aperçu des catégories que nous traitons chaque jour — d'un carton à des conteneurs complets.",
      viewAll: "Explorer toutes les catégories →",
    },
    startBrand: {
      overline: "Lancez votre marque", title: "Lancez votre propre marque en marque blanche et Amazon FBA",
      subtitle: "Transformez une idée de produit en marque prête pour le marché. Nous gérons le développement OEM/ODM, l'emballage personnalisé et la logistique FBA — concentrez-vous sur la vente.",
      cta: "Lancez votre marque", badge: "De l'idée à la mise en vente",
      p1: "Lots pilotes à faible quantité minimale", p2: "Image de marque et emballage prêts pour la vente",
      p3: "Préparation FBA, étiquetage et conformité", p4: "Un chef de marque dédié dès le premier jour",
    },
    video: {
      overline: "Voyez par vous-même", title: "Visites d'usines, inspections et preuves clients",
      subtitle: "La transparence crée la confiance. Découvrez des images réelles de nos audits d'usines, inspections QC et réussites clients.",
      viewAll: "Voir toutes les vidéos →",
    },
    testimonials: {
      overline: "Preuves clients", title: "Ce que disent les acheteurs du monde entier",
      subtitle: "Des résultats concrets d'importateurs, de marques et d'équipes d'achats qui nous confient leur chaîne d'approvisionnement.",
    },
    leadMagnet: {
      tag: "Téléchargement gratuit", namePh: "Nom complet", emailPh: "E-mail professionnel", companyPh: "Entreprise (facultatif)",
      submit: "Télécharger le guide gratuit", preparing: "Préparation…",
      successTitle: "Consultez votre téléchargement", success: "Nous vous en avons aussi envoyé une copie par e-mail.",
    },
    cta: {
      title: "Prêt à sourcer plus intelligemment et commercer en toute confiance ?",
      subtitle: "Obtenez un devis personnalisé en 24–48 h, ou parlez à un spécialiste du sourcing dès aujourd'hui. Sans engagement, sans pression.",
      requestQuote: "Demander un devis", whatsapp: "Discuter sur WhatsApp",
    },
    currency: {
      live: "Change en direct",
      note: "Taux de change indicatifs — ouvrez nos outils gratuits de change et d'expédition",
    },
    marketplaces: {
      overline: "Un partenaire, tous les marchés",
      title: "Nous sourçons sur toutes les grandes places de marché chinoises",
      subtitle: "Alibaba, Made-in-China, 1688, Pinduoduo et plus — nous vérifions les fournisseurs, négocions les prix directs d'usine et regroupons vos commandes en une seule expédition.",
      cta: "Sourcer ici",
      p0: "Vente en gros B2B mondiale",
      p1: "Fabricants chinois vérifiés",
      p2: "Prix de gros nationaux en Chine",
      p3: "Offres groupées directes d'usine",
      p4: "Vente en gros petites quantités",
      p5: "Détail et dropshipping",
    },
    about: {
      heroOverline: "À propos",
      heroTitle: "Votre partenaire de confiance pour le sourcing en Chine et le commerce mondial",
      heroSubtitle: "Unicorn Valley Group est un partenaire premium de sourcing, de fabrication et de logistique — conçu pour offrir aux acheteurs internationaux une manière plus sûre et plus intelligente de commercer.",
      whoOverline: "Qui nous sommes",
      whoTitle: "Un cabinet de conseil mondial, pas un simple transitaire",
      whoP1: "Nous avons créé Unicorn Valley Group parce qu'importer de Chine ne devrait pas signifier des nuits blanches à s'inquiéter de la fraude, de la qualité ou des retards. Avec des équipes sur le terrain à Shenzhen, Guangzhou et Ningbo, nous sommes vos yeux, vos oreilles et vos négociateurs en Chine.",
      whoP2: "Des startups lançant leur premier produit aux équipes gouvernementales achetant à grande échelle, nos clients comptent sur nous pour des conseils honnêtes, des fournisseurs vérifiés et une exécution de bout en bout.",
      statYears: "Ans d'expertise commerciale cumulée",
      statOffices: "Bureaux à travers la Chine",
      statRetention: "Taux de fidélisation client",
      missionTitle: "Notre mission",
      missionDesc: "Rendre le sourcing mondial transparent, sûr et sans effort pour les acheteurs du monde entier — en éliminant le risque et la complexité du commerce avec la Chine.",
      visionTitle: "Notre vision",
      visionDesc: "Être le pont le plus fiable entre les acheteurs internationaux et la fabrication chinoise, propulsant la prochaine génération de marques mondiales.",
      promiseTitle: "Notre promesse",
      promiseDesc: "Usines vérifiées, contrôle qualité rigoureux et paiements protégés — chaque commande, à chaque fois, sans exception.",
      coverageTitle: "Couverture mondiale",
      coverageSubtitle: "Nous expédions vers plus de 47 pays avec une expertise dédiée à l'importation sur les marchés clés :",
    },
    servicesPage: {
      heroOverline: "Nos services",
      heroTitle: "Tout ce dont vous avez besoin pour importer de Chine",
      heroSubtitle: "Un service commercial complet et géré — de la recherche de la bonne usine à la livraison à votre porte.",
      explore: "Découvrir le service",
    },
    industriesPage: {
      heroOverline: "Secteurs",
      heroTitle: "Un sourcing sur mesure pour chaque secteur",
      heroSubtitle: "Nous comprenons les besoins uniques de conformité, de volume et de qualité de chaque secteur que nous servons.",
      sourceFor: "Sourcer pour ce secteur →",
    },
    blogPage: {
      heroOverline: "Centre d'intelligence commerciale",
      heroTitle: "Des idées pour importer plus intelligemment",
      heroSubtitle: "Des guides pratiques sur le sourcing, la logistique, la qualité et le commerce mondial — rédigés par nos experts basés en Chine.",
      readArticle: "Lire l'article",
      all: "Tout",
    },
    countryPage: {
      home: "Accueil", destinations: "Destinations d'importation",
      importTitlePre: "Importer de Chine vers", getQuoteTo: "Obtenir un devis pour",
      bookConsult: "Réserver une consultation", shippingTo: "Expédition vers",
      transitTitle: "Délais de transit et modes de fret",
      seaFreight: "Fret maritime", airFreight: "Fret aérien", express: "Express",
      popularImports: "Importations populaires vers", customsOverline: "Douane et conformité",
      importingToPre: "Importer vers", importingToPost: ", dans les règles de l'art",
      faq: "FAQ", otherDestinations: "Autres destinations d'importation",
    },
    footer: {
      tagline: "Votre partenaire premium de sourcing en Chine, de fabrication et de commerce mondial. Usines vérifiées, qualité assurée, livré dans le monde entier.",
      explore: "Explorer", company: "Entreprise", getInTouch: "Contact",
      aboutUs: "À propos", resources: "Ressources", bookConsult: "Réserver une consultation",
      requestQuote: "Demander un devis", clientLogin: "Espace client", destinations: "Destinations d'importation",
      rights: "Tous droits réservés.", premium: "Sourcing premium en Chine · Fabrication · Commerce mondial",
    },
    contact: {
      overline: "Contact", title: "Démarrons votre projet de sourcing",
      subtitle: "Demandez un devis, réservez une consultation gratuite ou posez-nous simplement une question. Nous répondons sous 24 heures.",
      tabQuote: "Demander un devis", tabConsult: "Réserver une consultation", tabGeneral: "Demande générale",
      name: "Nom complet *", email: "E-mail *", phone: "Téléphone / WhatsApp", company: "Entreprise",
      quantity: "Quantité (ex. 500 unités / 1x40ft)", destination: "Pays de destination *",
      product: "Décrivez le(s) produit(s) à sourcer *", prefDate: "Date préférée",
      prefTime: "Heure préférée", topic: "Sujet (ex. marque blanche, logistique)",
      consultMsg: "Quelque chose à savoir ?", generalMsg: "Comment pouvons-nous aider ? *",
      submitQuote: "Obtenir mon devis", submitConsult: "Réserver une consultation", submitGeneral: "Envoyer le message",
      submitting: "Envoi…", thankYou: "Merci !",
      talkTo: "Parlez-nous directement", messageUs: "Écrivez-nous maintenant",
      whyChoose: "Pourquoi les acheteurs nous choisissent",
      why1: "Réponse sous 24 heures", why2: "Devis en 24–48 h",
      why3: "Sans engagement, sans pression", why4: "Usines vérifiées uniquement",
      chatWhatsapp: "Discuter sur WhatsApp",
      successQuote: "Demande de devis reçue. Nous vous enverrons votre devis personnalisé sous 24-48 h.",
      successConsult: "Consultation demandée. Nous confirmerons votre créneau par e-mail sous peu.",
      successGeneral: "Merci ! Notre équipe vous contactera sous 24 heures.",
      tabSupplier: "Vérifier un fournisseur", tabAudit: "Audit d'usine",
      supplierName: "Nom du fournisseur *", supplierContact: "Site web / WeChat / URL du fournisseur",
      productInterest: "Produit concerné", supplierNotes: "Que souhaitez-vous que nous vérifiions ?",
      factoryName: "Nom de l'usine / du fournisseur *", factoryLocation: "Emplacement de l'usine (ville)",
      auditType: "Sélectionnez le type d'audit", auditNotes: "Quelque chose de précis à inspecter ?",
      submitSupplier: "Demander une vérification", submitAudit: "Demander un audit",
      successSupplier: "Demande de vérification reçue. Notre équipe vous répondra sous 2-3 jours ouvrés.",
      successAudit: "Demande d'audit reçue. Nous confirmerons la portée et le calendrier sous 24 heures.",
    },
  },

  sw: {
    lang: { choose: "Lugha" },
    booking: {
      pickDate: "1. Chagua tarehe", pickTime: "2. Chagua muda (saa za China, GMT+8)",
      noSlots: "Hakuna nafasi siku hii — tafadhali jaribu siku nyingine.",
      loadingSlots: "Inapakia nyakati zilizopo…", bookBtn: "Thibitisha Miadi",
      success: "Miadi yako imewekwa! Tutakutumia uthibitisho kwa barua pepe.",
      slotTaken: "Nafasi hiyo imechukuliwa sasa hivi — tafadhali chagua nyingine.",
      chooseSlotFirst: "Tafadhali chagua tarehe na muda kwanza.",
    },
    blogNews: { overline: "Habari", title: "Blogu & Habari", viewAll: "Tazama makala zote" },
    caseStudies: {
      overline: "Mifano ya Mafanikio", title: "Matokeo halisi kwa waagizaji halisi",
      subtitle: "Ona jinsi biashara changa, wauzaji na timu za ununuzi walivyotumia Unicorn Valley Group kuagiza kwa usalama na kukua haraka.",
      challenge: "Changamoto", approach: "Mbinu Yetu", results: "Matokeo",
      back: "Mifano yote ya mafanikio", read: "Soma mfano wa mafanikio", watch: "Tazama video za wateja",
    },
    nav: {
      services: "Huduma", industries: "Sekta", products: "Bidhaa",
      startBrand: "Anzisha Chapa Yako", blog: "Maarifa ya Biashara", caseStudies: "Mifano ya Mafanikio",
      tools: "Zana", about: "Kuhusu", login: "Ingia Mteja", dashboard: "Dashibodi",
      admin: "Msimamizi", logout: "Toka", requestQuote: "Omba Nukuu",
    },
    hero: {
      overline: "Kutafuta Bidhaa China · Utengenezaji · Biashara ya Kimataifa",
      titlePre: "Tafuta bidhaa bora kutoka China. ", titleHighlight: "Fanya biashara duniani",
      titlePost: " kwa ujasiri.",
      subtitle: "Tunaunganisha wanunuzi wa kimataifa na watengenezaji waliothibitishwa — tukishughulikia utafutaji, udhibiti wa ubora, malipo salama na usafirishaji wa mlango hadi mlango, ili uagize bila wasiwasi.",
      ctaQuote: "Omba Nukuu", ctaConsult: "Weka Mashauriano ya Bure", watch: "Tazama jinsi inavyofanya kazi",
    },
    trust: {
      verifiedManufacturers: "Watengenezaji Waliothibitishwa", securePayments: "Malipo Salama ya Biashara",
      doorToDoor: "Usafirishaji Mlango hadi Mlango", qa: "Uhakikisho wa Ubora wa AQL",
    },
    marquee: { trustedBy: "Wanaaminiwa na wanunuzi wanaosafirisha kwa nchi 47+" },
    services: {
      overline: "Tunachofanya", title: "Huduma kamili za biashara, mahali pamoja",
      subtitle: "Kuanzia utafutaji wa kwanza wa wasambazaji hadi utoaji wa mwisho, tunasimamia kila hatua ili usihangaike na wasambazaji wengi.",
      viewAll: "Tazama huduma zote →", learnMore: "Jifunze zaidi",
    },
    industries: {
      overline: "Sekta tunazohudumia", title: "Imejengwa kwa wanunuzi wa kila sekta",
      subtitle: "Iwe wewe ni muuzaji binafsi wa Amazon au timu ya ununuzi wa serikali, mfumo wetu wa utafutaji unakidhi mahitaji yako.",
    },
    stats: {
      overline: "Kwa nini utuchague", title: "Rekodi inayoaminiwa na wanunuzi wa kimataifa",
      clients: "Wateja waliohudumiwa duniani", factories: "Viwanda vilivyothibitishwa",
      countries: "Nchi zinazohudumiwa", containers: "Makontena yaliyosafirishwa",
    },
    how: {
      overline: "Jinsi inavyofanya kazi", title: "Kutoka ombi hadi utoaji kwa hatua nne",
      subtitle: "Mchakato wazi na unaosimamiwa unaokufahamisha katika kila hatua.",
      s1: { title: "Shiriki Mahitaji Yako", desc: "Tueleze unachotaka kutafuta, bei unayolenga, na soko la mahali pa kufikisha." },
      s2: { title: "Tunatafuta na Kuthibitisha", desc: "Tunachagua viwanda vilivyothibitishwa, kujadili bei, na kupanga sampuli." },
      s3: { title: "Udhibiti wa Ubora", desc: "Ukaguzi wa AQL kabla ya kusafirisha unahakikisha bidhaa zako zinakidhi vigezo." },
      s4: { title: "Safirisha na Fikisha", desc: "Tunashughulikia usafirishaji, forodha na utoaji wa mlango hadi mlango — ukifuatiliwa kikamilifu." },
    },
    categories: {
      overline: "Aina za bidhaa", title: "Tafuta karibu kila kitu, kwa kiwango chochote",
      subtitle: "Mwonekano wa aina tunazoshughulikia kila siku — kutoka kartoni moja hadi makontena kamili.",
      viewAll: "Gundua aina zote →",
    },
    startBrand: {
      overline: "Anzisha chapa yako", title: "Zindua chapa yako binafsi na ya Amazon FBA",
      subtitle: "Geuza wazo la bidhaa kuwa chapa tayari kwa soko. Tunashughulikia uundaji wa OEM/ODM, ufungashaji maalum na usafirishaji wa FBA — wewe uzingatie kuuza.",
      cta: "Anzisha Chapa Yako", badge: "Kutoka wazo hadi kuorodheshwa",
      p1: "Uzalishaji wa majaribio wa kiwango kidogo", p2: "Chapa na ufungashaji tayari kwa rejareja",
      p3: "Maandalizi ya FBA, kuweka lebo na utii", p4: "Meneja wa chapa maalum tangu siku ya kwanza",
    },
    video: {
      overline: "Jionee mwenyewe", title: "Ziara za viwanda, ukaguzi na ushahidi wa wateja",
      subtitle: "Uwazi hujenga uaminifu. Tazama picha halisi za ukaguzi wa viwanda, ukaguzi wa ubora na hadithi za mafanikio za wateja.",
      viewAll: "Tazama video zote →",
    },
    testimonials: {
      overline: "Ushahidi wa wateja", title: "Wanunuzi duniani kote wanasemaje",
      subtitle: "Matokeo halisi kutoka kwa waagizaji, chapa na timu za ununuzi wanaotuamini kwa msururu wao wa usambazaji.",
    },
    leadMagnet: {
      tag: "Pakua bure", namePh: "Jina kamili", emailPh: "Barua pepe ya kazi", companyPh: "Kampuni (si lazima)",
      submit: "Pakua mwongozo wa bure", preparing: "Inaandaa…",
      successTitle: "Angalia upakuaji wako", success: "Pia tumekutumia nakala kwa barua pepe.",
    },
    cta: {
      title: "Uko tayari kutafuta bidhaa kwa busara na kufanya biashara kwa ujasiri?",
      subtitle: "Pata nukuu maalum ndani ya saa 24–48, au zungumza na mtaalamu wa utafutaji leo. Bila masharti, bila shinikizo.",
      requestQuote: "Omba Nukuu", whatsapp: "Piga gumzo WhatsApp",
    },
    currency: {
      live: "Viwango vya Sasa",
      note: "Viwango vya ubadilishaji vya makadirio — fungua zana zetu za bure za sarafu na usafirishaji",
    },
    marketplaces: {
      overline: "Mshirika mmoja, kila soko",
      title: "Tunatafuta bidhaa katika masoko yote makubwa ya China",
      subtitle: "Alibaba, Made-in-China, 1688, Pinduoduo na zaidi — tunathibitisha wasambazaji, kujadili bei za moja kwa moja za kiwanda na kuunganisha oda zako kuwa usafirishaji mmoja.",
      cta: "Tafuta hapa",
      p0: "Jumla ya B2B duniani",
      p1: "Watengenezaji wa China waliothibitishwa",
      p2: "Bei za jumla za ndani ya China",
      p3: "Ofa za pamoja moja kwa moja kutoka kiwanda",
      p4: "Jumla ya oda ndogo",
      p5: "Rejareja na dropshipping",
    },
    about: {
      heroOverline: "Kuhusu sisi",
      heroTitle: "Mshirika wako unayemwamini katika utafutaji bidhaa China na biashara ya kimataifa",
      heroSubtitle: "Unicorn Valley Group ni mshirika bora wa utafutaji, utengenezaji na usafirishaji — uliojengwa kuwapa wanunuzi wa kimataifa njia salama na bora zaidi ya kufanya biashara.",
      whoOverline: "Sisi ni nani",
      whoTitle: "Kampuni ya ushauri ya kimataifa, si tu wakala wa usafirishaji",
      whoP1: "Tulianzisha Unicorn Valley Group kwa sababu kuagiza kutoka China hakupaswi kumaanisha usiku wa kukosa usingizi ukiwa na wasiwasi wa udanganyifu, ubora au ucheleweshaji. Tukiwa na timu Shenzhen, Guangzhou na Ningbo, tunafanya kazi kama macho, masikio na wajadili wako ndani ya China.",
      whoP2: "Kuanzia kampuni changa zinazozindua bidhaa yao ya kwanza hadi timu za serikali zinazonunua kwa wingi, wateja wetu wanatutegemea kwa ushauri wa kweli, wasambazaji waliothibitishwa na utekelezaji kamili.",
      statYears: "Miaka ya uzoefu wa biashara kwa pamoja",
      statOffices: "Ofisi kote China",
      statRetention: "Kiwango cha kubaki kwa wateja",
      missionTitle: "Dhamira Yetu",
      missionDesc: "Kufanya utafutaji wa bidhaa duniani kuwa wazi, salama na rahisi kwa wanunuzi kila mahali — kuondoa hatari na ugumu wa kufanya biashara na China.",
      visionTitle: "Maono Yetu",
      visionDesc: "Kuwa daraja linaloaminika zaidi kati ya wanunuzi wa kimataifa na utengenezaji wa China, tukiwezesha kizazi kijacho cha chapa za kimataifa.",
      promiseTitle: "Ahadi Yetu",
      promiseDesc: "Viwanda vilivyothibitishwa, udhibiti mkali wa ubora na malipo yaliyolindwa — kila oda, kila wakati, bila ubaguzi.",
      coverageTitle: "Huduma ya kimataifa",
      coverageSubtitle: "Tunasafirisha kwa nchi 47+ tukiwa na utaalamu maalum wa kuagiza katika masoko muhimu:",
    },
    servicesPage: {
      heroOverline: "Huduma zetu",
      heroTitle: "Kila kitu unachohitaji kuagiza kutoka China",
      heroSubtitle: "Huduma kamili ya biashara inayosimamiwa — kutoka kupata kiwanda sahihi hadi kufikisha bidhaa mlangoni kwako.",
      explore: "Chunguza huduma",
    },
    industriesPage: {
      heroOverline: "Sekta",
      heroTitle: "Utafutaji maalum kwa kila sekta",
      heroSubtitle: "Tunaelewa mahitaji ya kipekee ya utii, wingi na ubora wa kila sekta tunayohudumia.",
      sourceFor: "Tafuta kwa sekta hii →",
    },
    blogPage: {
      heroOverline: "Kituo cha Maarifa ya Biashara",
      heroTitle: "Maarifa ya kuagiza kwa busara",
      heroSubtitle: "Miongozo ya vitendo kuhusu utafutaji, usafirishaji, ubora na biashara ya kimataifa — iliyoandikwa na wataalamu wetu walioko China.",
      readArticle: "Soma makala",
      all: "Zote",
    },
    countryPage: {
      home: "Nyumbani", destinations: "Mahali pa Kuagiza",
      importTitlePre: "Agiza kutoka China hadi", getQuoteTo: "Pata Nukuu ya",
      bookConsult: "Weka Mashauriano", shippingTo: "Usafirishaji hadi",
      transitTitle: "Muda wa usafiri na njia za mizigo",
      seaFreight: "Usafiri wa Bahari", airFreight: "Usafiri wa Anga", express: "Express",
      popularImports: "Bidhaa maarufu zinazoagizwa hadi", customsOverline: "Forodha na utii",
      importingToPre: "Kuagiza hadi", importingToPost: ", kwa kufuata sheria",
      faq: "Maswali", otherDestinations: "Mahali pengine pa kuagiza",
    },
    footer: {
      tagline: "Mshirika wako bora wa utafutaji bidhaa China, utengenezaji na biashara ya kimataifa. Viwanda vilivyothibitishwa, ubora uliohakikishwa, vinafikishwa duniani kote.",
      explore: "Gundua", company: "Kampuni", getInTouch: "Wasiliana nasi",
      aboutUs: "Kuhusu Sisi", resources: "Rasilimali", bookConsult: "Weka Mashauriano",
      requestQuote: "Omba Nukuu", clientLogin: "Ingia Mteja", destinations: "Mahali pa Kuagiza",
      rights: "Haki zote zimehifadhiwa.", premium: "Utafutaji Bora China · Utengenezaji · Biashara ya Kimataifa",
    },
    contact: {
      overline: "Wasiliana nasi", title: "Tuanze mradi wako wa utafutaji",
      subtitle: "Omba nukuu, weka mashauriano ya bure au tuulize swali tu. Tunajibu ndani ya saa 24.",
      tabQuote: "Omba Nukuu", tabConsult: "Weka Mashauriano", tabGeneral: "Swali la Jumla",
      name: "Jina kamili *", email: "Barua pepe *", phone: "Simu / WhatsApp", company: "Kampuni",
      quantity: "Kiasi (mf. vipande 500 / 1x40ft)", destination: "Nchi ya kufikisha *",
      product: "Eleza bidhaa unazotaka kutafuta *", prefDate: "Tarehe unayopendelea",
      prefTime: "Saa unayopendelea", topic: "Mada (mf. chapa binafsi, usafirishaji)",
      consultMsg: "Kuna jambo tunalopaswa kujua?", generalMsg: "Tunawezaje kusaidia? *",
      submitQuote: "Pata Nukuu Yangu", submitConsult: "Weka Mashauriano", submitGeneral: "Tuma Ujumbe",
      submitting: "Inatuma…", thankYou: "Asante!",
      talkTo: "Zungumza nasi moja kwa moja", messageUs: "Tutumie ujumbe sasa",
      whyChoose: "Kwa nini wanunuzi wanatuchagua",
      why1: "Jibu ndani ya saa 24", why2: "Nukuu ndani ya saa 24–48",
      why3: "Bila masharti, bila shinikizo", why4: "Viwanda vilivyothibitishwa pekee",
      chatWhatsapp: "Piga gumzo kupitia WhatsApp",
      successQuote: "Ombi la nukuu limepokelewa. Tutakutumia nukuu yako maalum ndani ya saa 24-48.",
      successConsult: "Mashauriano yameombwa. Tutathibitisha muda wako kwa barua pepe hivi karibuni.",
      successGeneral: "Asante! Timu yetu itawasiliana nawe ndani ya saa 24.",
      tabSupplier: "Thibitisha Msambazaji", tabAudit: "Ukaguzi wa Kiwanda",
      supplierName: "Jina la msambazaji *", supplierContact: "Tovuti / WeChat / URL ya msambazaji",
      productInterest: "Bidhaa inayohusika", supplierNotes: "Ungependa tukague nini?",
      factoryName: "Jina la kiwanda / msambazaji *", factoryLocation: "Mahali kiwanda kilipo (jiji)",
      auditType: "Chagua aina ya ukaguzi", auditNotes: "Kuna kitu maalum cha kukagua?",
      submitSupplier: "Omba Uthibitisho", submitAudit: "Omba Ukaguzi",
      successSupplier: "Ombi la uthibitisho limepokelewa. Timu yetu itakujibu ndani ya siku 2-3 za kazi.",
      successAudit: "Ombi la ukaguzi limepokelewa. Tutathibitisha wigo na ratiba ndani ya saa 24.",
    },
  },
};
